import React, { useState, useImperativeHandle, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from '@mui/material'
import { Colors } from 'Theme'
import { IFTabs } from 'Components'
import AdminPageTabsSkeleton from './AdminPageTabsSkeleton'

const AdminPageTabs = React.forwardRef(
  (
    {
      onValueChange,
      isLoading,
      initialIndex,
      AdminCount,
      fetchListRequestState,
      RoleCount,
      InvitationCount,
      canViewRoles,
    },
    ref,
  ) => {
    const tabTitles = {
      Admins: 'Admins',
      Invitations: 'Invitations',
      ...(canViewRoles && { Roles: 'Roles' }),
    }
    const [selectedIndex, setSelectedIndex] = useState(initialIndex)
    useEffect(() => {
      setSelectedIndex(initialIndex)
    }, [initialIndex])
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    return (
      <div>
        {isLoading ? (
          <AdminPageTabsSkeleton tabsCount={Object.keys(tabTitles).length} />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {Object.entries(tabTitles).map(([key, title], index) => (
              <Tab
                sx={{
                  padding: '0px',
                  minWidth: 'fit-content',
                  maxWidth: 'fit-content',
                }}
                key={index}
                label={
                  <IFTabs
                    title={title}
                    isSelected={selectedIndex === index}
                    fetchListRequestState={fetchListRequestState}
                    count={
                      key === 'Admins'
                        ? AdminCount
                        : key === 'Invitations'
                        ? InvitationCount
                        : RoleCount
                    }
                  />
                }
              />
            ))}
          </Tabs>
        )}
      </div>
    )
  },
)

AdminPageTabs.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  initialIndex: PropTypes.number,
  AdminCount: PropTypes.number,
  RoleCount: PropTypes.number,
  InvitationCount: PropTypes.number,
  isLoading: PropTypes.bool,
  canViewRoles: PropTypes.bool,
}

export default AdminPageTabs
